import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

//package import

import {
  Box,
  Typography,
  Grid,
  Avatar,
  Paper,
  useTheme,
  IconButton,
  MenuItem,
  Menu,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Logout as LogoutIcon } from "@mui/icons-material";

//user import

import Globe from "../../../Svg/Globe";
import Delivery from "../../../Svg/Delivery";
import Wastedvaccine from "../../../Svg/Wastedvaccine";
import Vaccinated from "../../../Svg/Vaccinated";
import { RoutesUrls, adminRoutes } from "../../../Services/Routes/APP";
import Piechart from "../../shared/PieChart";
import Barchart from "../../shared/Barchart";
import { admin_Context } from "../../../context";
import { headersPost } from "../../../Services/API";
import { ADMIN_API_ULRS } from "../../../Services/Routes/API";
import { useDecodedToken } from "../../../Services/Routes/APP/PrivateRoute";

//constants

const headings = ["", "", "Date", "Units Requested", "Actions"];

const rows = [
  {
    most_recent: "Sydney",
    date: "27-12-2021",
    units_requested: "10 K",
  },
  {
    most_recent: "Queens Land",
    date: "27-12-2021",
    units_requested: "10 K",
  },
  {
    most_recent: "Victoria",
    date: "27-12-2021",
    units_requested: "10 K",
  },
  {
    most_recent: "Tasmania",
    date: "19-12-2021",
    units_requested: "10 K",
  },
];

//component

const Dashboard = () => {
  //hooks

  const theme = useTheme();
  const navigate = useNavigate();
  const user = useDecodedToken();

  //states

  const [anchorEl, setAnchorEl] = useState(null);
  const [barChartData, setBarChartData] = useState(null);
  const [pieChartData, setPieChartData] = useState(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [childNodes, setChildNodes] = useState("");
  const [vaccinesUsedCount, setVaccinesUsedCount] = useState("");
  const [wastedCount, setWastedCount] = useState("");
  const [totalTransferedCount, setTotalTransferedCount] = useState("");

  //constants

  const open = Boolean(anchorEl);

  //constants

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  //menu close handler

  const handleClose = () => {
    setAnchorEl(null);
  };

  //addHandler Function ..

  const addHandler = () => {
    navigate(RoutesUrls.admin + adminRoutes.detailsDashboard);
  };

  const addHandler2 = () => {
    navigate(RoutesUrls.admin + adminRoutes.seemoreDashboard);
  };

  // logout handler

  const logoutHandler = () => {
    localStorage.clear();
    navigate(RoutesUrls?.root);
  };

  // dashboard data

  const getDashboardData = () => {
    const data = {
      dashboard_request: {
        view_level: "super_admin",
      },
    };

    headersPost(ADMIN_API_ULRS.GET_DASHBOARD_DATA, data)
      .then((res) => {
        if (res?.status === 200 && res?.data?.success) {
          setBarChartData(res.data?.barChartData);
          setPieChartData(res.data?.pieChartData);
          setChildNodes(res.data?.total_child_nodes);
          setTotalTransferedCount(res.data?.total_transferred);
          setVaccinesUsedCount(res.data?.vaccinated_count);
          setWastedCount(res.data?.wasted_count);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  // life cycle

  useEffect(() => {
    getDashboardData();
  }, []);

  //render

  return (
    <>
      <Grid container spacing={1} mt={4} alignItems={"stretch"}>
        <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
          {/* <Box display={"flex"} height={"100%"}> */}
          <Paper
            elevation={1}
            sx={{ borderRadius: 1, padding: theme.spacing(2) }}
          >
            <Box display={"flex"}>
              <Box>
                <Globe width={"70px"} height={"70px"}></Globe>
              </Box>
              <Box
                sx={{
                  margin: { xs: "7px", sm: "7px" },
                  lineHeight: { xs: "1.235", sm: "1.235" },
                  fontSize: { xs: "1.5625rem", sm: "1.5625rem" },
                  fontWeight: { xs: 700, sm: 700 },
                  fontFamily: {
                    xs: "Inter,sans-serif",
                    sm: "Inter,sans-serif",
                  },
                  marginLeft: { xs: 2, sm: 2, md: 4, lg: 4 },
                  height: "65px",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: "bold",
                    marginBottom: { sm: 1, xs: 1, md: 1, lg: 1 },
                  }}
                >
                  {childNodes}
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{
                    lineHeight: { sm: 1, xs: 1, md: 1, lg: 1 },
                    color: "text.secondary",
                  }}
                >
                  Total countries of operation.
                </Typography>
              </Box>
            </Box>
          </Paper>
          {/* </Box> */}
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
          {/* <Box display={"flex"} height={"100%"}> */}
          <Paper
            elevation={1}
            sx={{ borderRadius: 1, padding: theme.spacing(2) }}
          >
            {" "}
            <Box display={"flex"}>
              <Box>
                <Delivery width={"70px"} height={"70px"} />
              </Box>
              <Box
                height={"77px"}
                sx={{
                  margin: { xs: "7px", sm: "7px" },
                  lineHeight: { xs: "1.235", sm: "1.235" },
                  fontSize: { xs: "1.5625rem", sm: "1.5625rem" },
                  fontWeight: { xs: 700, sm: 700 },
                  fontFamily: {
                    xs: "Inter,sans-serif",
                    sm: "Inter,sans-serif",
                  },
                  marginLeft: { xs: 2, sm: 2, md: 4, lg: 4 },
                  height: "65px",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: "bold",
                    marginBottom: { sm: 1, xs: 1, md: 1, lg: 1 },
                  }}
                >
                  {totalTransferedCount}
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{
                    lineHeight: { sm: 1, xs: 1, md: 1, lg: 1 },
                    color: "text.secondary",
                  }}
                >
                  Vaccines delivered world wide.
                </Typography>
              </Box>
            </Box>
          </Paper>
          {/* </Box> */}
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
          {/* <Box display={"flex"} height={"100%"}> */}
          <Paper
            elevation={1}
            sx={{ borderRadius: 1, padding: theme.spacing(2) }}
          >
            {" "}
            <Box display={"flex"}>
              <Box>
                <Vaccinated width={"70px"} height={"70px"} />
              </Box>
              <Box
                sx={{
                  margin: { xs: "7px", sm: "7px" },
                  lineHeight: { xs: "1.235", sm: "1.235" },
                  fontSize: { xs: "1.5625rem", sm: "1.5625rem" },
                  fontWeight: { xs: 700, sm: 700 },
                  fontFamily: {
                    xs: "Inter,sans-serif",
                    sm: "Inter,sans-serif",
                  },
                  marginLeft: { xs: 2, sm: 2, md: 4, lg: 4 },
                  height: "65px",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: "bold",
                    marginBottom: { sm: 1, xs: 1, md: 1, lg: 1 },
                  }}
                >
                  {vaccinesUsedCount}
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{
                    lineHeight: { sm: 1, xs: 1, md: 1, lg: 1 },
                    color: "text.secondary",
                  }}
                >
                  Vaccine Used world wide.
                </Typography>
              </Box>
            </Box>
          </Paper>
          {/* </Box> */}
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
          {/* <Box display={"flex"} height={"100%"}> */}
          <Paper
            elevation={1}
            width={"100%"}
            sx={{ borderRadius: 1, padding: theme.spacing(2) }}
          >
            {" "}
            <Box display={"flex"}>
              <Box>
                <Wastedvaccine width={"70px"} height={"70px"} />
              </Box>
              <Box
                sx={{
                  margin: { xs: "7px", sm: "7px" },
                  lineHeight: { xs: "1.235", sm: "1.235" },
                  fontSize: { xs: "1.5625rem", sm: "1.5625rem" },
                  fontWeight: { xs: 700, sm: 700 },
                  fontFamily: {
                    xs: "Inter,sans-serif",
                    sm: "Inter,sans-serif",
                  },
                  marginLeft: { xs: 2, sm: 2, md: 4, lg: 4 },
                  height: "65px",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: "bold",
                    marginBottom: { sm: 1, xs: 1, md: 1, lg: 1 },
                  }}
                >
                  {wastedCount}
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{
                    lineHeight: { sm: 1, xs: 1, md: 1, lg: 1 },
                    color: "text.secondary",
                  }}
                >
                  Vaccine wasted world wide.
                </Typography>
              </Box>
            </Box>
          </Paper>
          {/* </Box> */}
        </Grid>
      </Grid>

      <Grid container mt={2} spacing={2}>
        {pieChartData && (
          <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
            <Paper elevation={1} sx={{ paddingBottom: 1 }}>
              <Typography variant="h5" pt={2} paddingX={2}>
                General Overview
              </Typography>
              <Typography
                variant="subtitle2"
                color={"text.grayText"}
                paddingX={2}
              >
                Overall Population Served
              </Typography>
              <Box
                width={"100%"}
                height={300}
                display={"flex"}
                justifyContent={"center"}
                pt={2}
              >
                {pieChartData?.[0]?.value === 0 ||
                  pieChartData?.[1]?.value === 0 ? (
                  <Typography
                    variant="body1"
                    color={"text.grayText"}
                    padding={2}
                    mt={7}
                  >
                    No Record Found
                  </Typography>
                ) : (
                  <Piechart data={pieChartData} height={285} />
                )}
              </Box>
              <Grid container mt={2} display={"flex"} justifyContent={"center"}>
                <Grid container paddingX={2}>
                  <Box
                    width={30}
                    borderRadius={2}
                    height={30}
                    bgcolor="#5E3FBE"
                  ></Box>
                  <Typography paddingX={2} color={"text.grayText"}>
                    Population Vaccinated
                  </Typography>
                </Grid>
                <Grid container padding={2}>
                  <Box
                    width={30}
                    borderRadius={2}
                    height={30}
                    bgcolor={theme.palette.grey.A100}
                  ></Box>
                  <Typography paddingX={2} color={"text.grayText"}>
                    Non - vaccinated
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        )}
        {barChartData && (
          <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
            <Paper elevation={1}>
              <Typography variant="h5" pt={2} paddingX={2}>
                Monthly Overview
              </Typography>
              <Typography
                variant="subtitle2"
                color={"text.grayText"}
                paddingX={2}
              >
                Population Served per month
              </Typography>
              <Box
                width={"98%"}
                height={400}
                display={"flex"}
                justifyContent={"center"}
                pt={4}
              >
                <Barchart data={barChartData} height={340} />
              </Box>
            </Paper>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default Dashboard;
